export default __webpack_public_path__ + "static/media/move-arte-4.ed1e8b90.webp";